import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { IconMenu, IconClose } from "./icons";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Close the mobile menu and jump to top whenever the route changes.
  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <header className="header">
        <div className="container header__row">
          <Link to="/" className="brand" aria-label="Agile Software Ltd — home">
            <Logo height={30} />
          </Link>

          <nav className="header__nav" hidden={!menuOpen} aria-label="Primary">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className="navlink">
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="header__actions">
            <Link to="/contact" className="btn">Start a project</Link>
            <button
              className="menu-toggle"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              {menuOpen ? <IconClose /> : <IconMenu />}
            </button>
          </div>
        </div>
      </header>

      <main id="main">
        <Outlet />
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer__top">
            <div>
              <Logo reversed height={30} />
              <p className="footer__blurb">
                Software integration and delivery for businesses that need to move
                quickly without breaking what already works.
              </p>
            </div>
            <div>
              <h4>Company</h4>
              <div className="footer__nav">
                <Link to="/services">Services</Link>
                <Link to="/about">About</Link>
                <Link to="/contact">Contact</Link>
              </div>
            </div>
            <div>
              <h4>Get in touch</h4>
              <div className="footer__nav">
                <a href="mailto:hello@agile-software.co.uk">hello@agile-software.co.uk</a>
                <a href="https://agile-software.co.uk">agile-software.co.uk</a>
              </div>
            </div>
          </div>
          <div className="footer__legal">
            <span>&copy; {"2026"} Agile Software Ltd. All rights reserved.</span>
            <span>
              Registered in England &amp; Wales &middot; Company No. 17346703
              &middot; Registered office: 2 Bridge Close, Crewe, CW2 6RL
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}
